import { useEffect } from 'react';
import { useNavigate } from 'react-router-dom';

import { Box, Button, SxProps, Theme, Typography } from '@mui/material';

import { useLanguage } from '../../hooks';
import { Datascope } from '../../icons';
import { closeIntercom, openIntercom } from '../../utils/intercom';
import { paths } from '../../utils/navigation';

const customStyles: Record<string, SxProps<Theme>> = {
  root: {
    height: '100vh',
    width: '100%',
    backgroundColor: '#FAFBFF',
    display: 'flex',
    flexDirection: 'column',
    justifyContent: 'center',
    alignItems: 'center',
    padding: '10px',
    boxSizing: 'border-box',
  },
  content: {
    maxWidth: '472px',
    display: 'flex',
    flexDirection: 'column',
    alignItems: 'center',
    gap: '16px',
  },
  title: {
    fontSize: '100px',
    fontWeight: 600,
    lineHeight: '100px',
    maxWidth: '475px',
    textAlign: 'center',
  },
  description: {
    fontSize: '16px',
    fontWeight: 400,
    lineHeight: '24px',
    maxWidth: '475px',
    textAlign: 'center',
    color: (theme) => theme.palette.secondary.main,
  },
  fullLogo: {
    width: '300px',
    height: 'auto',
    color: (theme) => theme.palette.primary.main,
    marginBottom: '36px',
  },
  button: {
    marginTop: '40px',
  },
};

export function NotFound() {
  const lang = useLanguage();
  const navigate = useNavigate();

  useEffect(() => {
    openIntercom();
  }, []);

  return (
    <Box sx={customStyles.root}>
      <Box sx={customStyles.content}>
        <Box>
          <Datascope sx={customStyles.fullLogo} />
        </Box>
        <Typography
          variant='h1'
          sx={customStyles.title}
        >
          {lang.notFound.title}
        </Typography>
        <Typography
          variant='h2'
          sx={customStyles.description}
        >
          {lang.notFound.description}
        </Typography>
        <Button
          fullWidth
          variant='contained'
          color='primary'
          sx={customStyles.button}
          onClick={() => {
            navigate(paths.home.index);
            closeIntercom();
          }}
        >
          {lang.notFound.button}
        </Button>
      </Box>
    </Box>
  );
}
